import React from "react";
import { flatten } from "ramda";
import PrettyDate from "../../common/components/PrettyDate";
import { primaryBlue } from "../../common/styles";
import { tdStyles } from "./monitorStyles";

const truncateListIfGreaterThan = (maxNum, list, suffix) => {
    return list.length > maxNum ? [list.length + suffix] : list;
};

const recipientEmailsToDisplay = (emailAddresses) => (
    truncateListIfGreaterThan(5, emailAddresses, " recipients")
);

const companyNamesToDisplay = (companyNames) => (
    truncateListIfGreaterThan(5, companyNames, " instruments or issuers")
);

const isEmpty = (string) => (string && string.trim() !== '');

const communicationStyle = (props) => {
    return Object.assign({},
        {
            cursor: "pointer"
        },
        props.isSelected && {
            backgroundColor: primaryBlue,
            color: "white"
        }
    );
};

const madeOnStyles = Object.assign({}, tdStyles, {
    minWidth: "11em"
});

const byStyles = Object.assign({}, tdStyles, {
    minWidth: "6.5em"
});

const recipientStyles = {
    maxWidth: "14em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};

const recommendedStyles = {
    maxWidth: "14em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};

const CommunicationRow = (props) => (
    <tr className="x-communication communication-row"
        key={props.id}
        onClick={() => props.onChange(props.id)}
        style={communicationStyle(props)}>

        <td style={madeOnStyles}>
            <PrettyDate date={props.disseminationTimestamp} timeOnSameLine={true}/>
        </td>

        <td className="x-communicator-name" style={byStyles}>
            {props.communicator !== null ? props.communicator.firstName + " " + props.communicator.lastName : ""}
        </td>

        <td style={tdStyles}>
            <div>
                {recipientEmailsToDisplay(props.recipientsEmailAddresses).map(r => <div
                    style={recipientStyles}>{r}</div>)}
            </div>
        </td>

        <td className="x-recommended" style={tdStyles}>{
            companyNamesToDisplay(
                flatten(props.presentations.map(presentation => presentation.legs.map(leg => leg.instrumentData.companyName))).filter(isEmpty)
            ).map(c => <div style={recommendedStyles}>{c}</div>)
        }</td>
    </tr>
);
CommunicationRow.propTypes = {
    onChange: React.PropTypes.func
};

export default CommunicationRow


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/CommunicationRow.js
 **/